var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.214844,
    width: 33.1416,
    height: 34.1959,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_45_21",
    transform: "matrix(0.0111111 0 0 0.0107685 0 0.0154154)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_45_21",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpklEQVR4nO3boW8UQRTH8YMSQtJAIEGQYBAYDAqDQoECQXHgkEgMAv6AChIMhpQEEiQKHAoMBgwGg0EgEKRNSAoBUvolk2xNQ3fm5mbevLn7fVST63ZvftmdffN2OpmIiIiIiIiIiIiIiIhIQcBR4C0S8x44PmvYy8Cr6KkW12vgcKkr+yDwvPWIHHoJHMoJdN/IZ0vAk9Yjc+QpcCAny/Dhs9jBwP3WI3TgIbA/clE+Hgs66XYA7rC4VlOn2VjQSRM8cAv4y+LYBm5PUzikBJ1UsgA3gD/Mvy3gZiSLY7tL4dSgg4/AycgJLgM/mV+/gWuRDE4AH3YfOE3QwWfgdOREF4DvzJ9N4FJk7KeAT/87eNqgg6/A2cgJzwHfmB8bwPnImM8AX/b6AzlBFzlxR4pcWLlB79xKF3NvpU4UmypnCTr4lftw6EDKw/9K6sN/1qCzyx3nipezJYLOKuAdq7JAKxX01EtSp6q1HEoHndxkwZ+qTbQaQVf/0hVUvzhqBd1T52/VYrqrGbT3zt+25QO8dtDBO4edvy3rktQi6OLFf6sOXA9Be+n8bc7Sgesl6Nadv42WjTDroFsNuHlrt0XQ1p0/D1NWs6CtOn9uXr+1DLp2mZXSgbtuVVa2DrrWwsHdQslD0KWXwi6X/p6CDh4k7PlbY29rCc2scA4WPWiGzZNLkStyBXgD/BgqmDBVXI0c03RjpseggxdZW2Adv3DwGnSxTd1eXqF5Djqp89fLv4N4D5phdTi6fB5ZxocFiws9BM3w0LubMpUAR4B73jZb9hL0jnXgUagwQv9imH+Xh59Xhs/C77jTW9DdUtBGFLQRBW1EQRtR0EYUtBEFbURBG1HQRhS0EQVtREEbUdBGFLSRWB9dREREREREREREREREJiP+AdaLJhJfih3lAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5316fd2b46bec585d5fe3edc97b1560d.svg";
export { ForwardRef as ReactComponent };